module.exports = __webpack_public_path__ + "static/media/eyeOpen.0aa04d29.svg";